export enum TipoEntitaAnagrafeEnum {
  SOGGETTO = <any>"SOGGETTO",
  RECAPITO = <any>"RECAPITO",
  LISTA_DISTRIBUZIONE = <any>"LISTA_DISTRIBUZIONE",
}
